import type { ConflitoGanttSecaoProps } from "./types-conflito-gantt-secao";
import { ConflitoGanttSecaoView } from "./view-conflito-gantt-secao";

/** Seção "Alocação de cada ..." da Revisão: título, legenda e o Gantt dos recursos envolvidos. */
export function ConflitoGanttSecao(props: ConflitoGanttSecaoProps) {
  return <ConflitoGanttSecaoView {...props} />;
}

export type * from "./types-conflito-gantt-secao";
